// @ts-nocheck
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import ProductContextAvailability from "@insite/content-library/Components/ProductContextAvailability";
import ProductPrice from "@insite/content-library/Components/ProductPrice";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductImage from "@store/Overrides/Components/ProductImage";
import ProductPartNumbers from "@store/Overrides/Components/ProductPartNumbers";
import ProductDiscontinued from "@store/Library/Components/ProductDiscontinued";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps {
    title: string;
}

type Props = OwnProps & HasProductContext;

export interface ProductDetailsExtraProductStyles {
    container?: GridContainerProps;
    titleGridItem?: GridItemProps;
    title?: TypographyPresentationProps;
    imageGridItem?: GridItemProps;
    linkGridItem?: GridItemProps;
    link?: LinkPresentationProps;
    productName?: TypographyPresentationProps;
    flexWrapper?: InjectableCss;
}

export const productDetailsExtraProductStyles: ProductDetailsExtraProductStyles = {
    container: {
        gap: 12,
    },
    titleGridItem: {
        width: 12,
    },
    title: {
        variant: "h3",
        forwardAs: "h2",
    },
    imageGridItem: {
        width: 4,
    },
    linkGridItem: {
        width: 8,
        css: css`
            flex-direction: column;
            justify-content: center;
            gap: ${pxToRem(10)};
        `,
    },
    productName: {
        variant: "p",
        forwardAs: "h3",
    },
};

const styles = productDetailsExtraProductStyles;

const ProductDetailsExtraProductTile = ({ title, productContext }: Props) => {
    const product: ProductModel = productContext.product;

    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.titleGridItem}>
                <Typography {...styles.title}>{title}</Typography>
            </GridItem>
            <GridItem {...styles.imageGridItem}>
                <ProductImage product={product} href={product.canonicalUrl} />
            </GridItem>
            <GridItem {...styles.linkGridItem}>
                <Link href={product.canonicalUrl} {...styles.link}>
                    <Typography {...styles.productName}>{product.productTitle}</Typography>
                </Link>
                <ProductDiscontinued product={product} />
                <ProductPartNumbers
                    productNumber={product.productNumber}
                    customerProductNumber={product.customerProductNumber}
                    manufacturerItem={product.manufacturerItem}
                />
                <ProductContextAvailability />
                <ProductPrice product={productContext} showLabel={false} showSavings={true} />
            </GridItem>
        </GridContainer>
    );
};

export default withProductContext(ProductDetailsExtraProductTile);
